import { useMemo } from 'react';
import { Filtro } from '../interfaces/Indicator';
import { colors } from '../utils/colors';

type DataKey = { key: string; color: string };

const useDataKey = (data: any[], filters: Filtro[] | undefined) => {
    const dataKey = useMemo<DataKey[] | null>(() => {
        if (!data?.length) return null;

        const keys = Object.keys(data[0]).slice(1);

        return keys.map((key, index) => {
            let color = colors[index % colors.length];

            if (filters && filters.length > 0) {
                for (const filter of filters) {
                    const foundValue = filter.values.find(v => v.value.trim().toLowerCase() === key.trim().toLowerCase());
                    if (foundValue?.color) {
                        color = foundValue.color;
                        break;
                    }
                }
            }

            return { key, color };
        });
    }, [data, filters]);

    return { dataKey };
};

export default useDataKey;